<template>
  <div>
    <section-collapseable
      title="Appointments"
      :sub-title="appointments.length.toString()"
      button-text="Appointment"
      @add="$refs.appointmentModal.open()"
      :collapseable="!!appointments.length"
      :hide-initial-always="!isLoading && !appointments.length"
      hide-initial-when-expanded
      :is-loading="isLoading"
    >
      <!-- Next Appointment -->
      <div v-if="nextAppointment">
        <appointment-item
          :appointment="nextAppointment"
          is-next-appointment
          @edit="$refs.appointmentModal.open($event)"
        ></appointment-item>
      </div>

      <!-- All Appointments -->
      <template v-slot:expanded>
        <template v-if="appointments.length">
          <appointment-item
            v-for="appointment in futureAppointments"
            :key="appointment.id"
            :appointment="appointment"
            @edit="$refs.appointmentModal.open($event)"
          ></appointment-item>

          <template v-if="pastAppointments.length">
            <div v-if="hidePast" class="flex flex-centered mt-2">
              <button-link
                @click="hidePast = false"
              >View {{ pastAppointments.length }} past appointment{{ pastAppointments.length ? 's' : ''}}</button-link>
            </div>

            <template v-else>
              <div class="flex flex-centered mt-2">
                <button-link
                  @click="hidePast = true"
                >Hide past appointment{{ pastAppointments.length ? 's' : ''}}</button-link>
              </div>

              <appointment-item
                v-for="appointment in pastAppointments"
                :key="appointment.id"
                :appointment="appointment"
                @edit="$refs.appointmentModal.open($event)"
              ></appointment-item>
            </template>
          </template>
        </template>

        <p v-else class="no_appointments">This lead has no appointments, yet.</p>
      </template>
    </section-collapseable>

    <!-- Appointment Modal -->
    <modal-container>
      <modal-crud-form
        ref="appointmentModal"
        title="Appointment"
        form-component="appointment-form"
        is-wide
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
import AppointmentItem from "../components/AppointmentItem";

export default {
  name: "LeadAppointments",
  components: {AppointmentItem},
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      hidePast: true
    }
  },
  watch: {
    '$store.state.modals.editAppointment' () {
      if (! this.$store.state.modals.editAppointment) {
        this.$refs.appointmentModal.close()
      }
    }
  },
  computed: {
    appointments() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord.appointments : [];
    },
    futureAppointments() {
      let now = new Date();
      return this.sortAppointments(this.appointments.filter(appointment => new Date(appointment.start_at) > now));
    },
    pastAppointments() {
      let now = new Date();
      return this.sortAppointments(this.appointments.filter(appointment => new Date(appointment.start_at) < now));
    },
    nextAppointment() {
      if (this.futureAppointments.length) {
        const activeAppointments = this.futureAppointments.filter(appointment => appointment.canceled_at === null);
        return activeAppointments[0];
      }
      return null;
    },
  },
  methods: {
    sortAppointments(appointments) {
      return appointments.sort((a,b) => new Date(a.start_at) - new Date(b.start_at));
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.next_appointment {
  margin-top: 10px;

  &--time {
    margin-bottom: -0.25rem;
    font-size: 0.875rem;
  }
}

.no_appointments {
  margin: 1rem 0;
}
</style>
